module.exports = __webpack_public_path__ + "images/icons/fa_calendar_week-4e13948bb867ba3ab0430eebffcfc400.svg";